import React, { Fragment, useEffect, useState } from "react";
import { getSortedProducts } from "./utils";
import { decodeText } from "../../../utils/richText";
import Paginator from "react-hooks-paginator";
import ShopProducts from "./ShopProducts";
import ShopTopbar from "./ShopTopbar";
import ShopSidebar from "./ShopSidebar";

const ProductList = ({ products }) => {
    const [layout, setLayout] = useState("grid three-column");
    const [searchTerm, setSearchTerm] = useState("");
    const [sortType, setSortType] = useState("");
    const [sortValue, setSortValue] = useState("");
    const [filterSortType, setFilterSortType] = useState("");
    const [filterSortValue, setFilterSortValue] = useState("");
    const [offset, setOffset] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [currentData, setCurrentData] = useState([]);
    const [sortedProducts, setSortedProducts] = useState([]);

    const pageLimit = 15;

    const getLayout = (layout) => {
        setLayout(layout);
    };

    const getSortParams = (sortType, sortValue) => {
        setSortType(sortType);
        setSortValue(sortValue);
    };

    const getFilterSortParams = (sortType, sortValue) => {
        setFilterSortType(sortType);
        setFilterSortValue(sortValue);
    };

    // Client-side search over the loaded category: name and short description, case-insensitive.
    // A new term starts at the first page again.
    const onSearch = (term) => {
        setSearchTerm(term);
        setOffset(0);
        setCurrentPage(1);
    };

    const matchesSearch = (product, term) =>
        [product.displayName, product.shortDescription].some((text) => typeof text === "string" && decodeText(text).toLowerCase().includes(term));

    useEffect(() => {
        const term = searchTerm.trim().toLowerCase();
        const searched = term ? products.filter((product) => matchesSearch(product, term)) : products;
        let sortedProducts = getSortedProducts(searched, sortType, sortValue);
        const filterSortedProducts = getSortedProducts(sortedProducts, filterSortType, filterSortValue);
        sortedProducts = filterSortedProducts;
        setSortedProducts(sortedProducts);
        setCurrentData(sortedProducts.slice(offset, offset + pageLimit));
    }, [offset, products, sortType, sortValue, filterSortType, filterSortValue, searchTerm]);

    return (
        <Fragment>
            <div className="shop-area pt-95 pb-100">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-3 order-2 order-lg-1">
                            {/* shop sidebar */}
                            <ShopSidebar products={products} getSortParams={getSortParams} sideSpaceClass="me-30" searchTerm={searchTerm} onSearch={onSearch} />
                        </div>
                        <div className="col-lg-9 order-1 order-lg-2">
                            {/* shop topbar default */}
                            <ShopTopbar
                                layout={layout}
                                getLayout={getLayout}
                                getFilterSortParams={getFilterSortParams}
                                productCount={products.length}
                                sortedProductCount={currentData.length}
                            />

                            {/* shop page content default */}
                            <ShopProducts layout={layout} products={currentData} />

                            {/* shop product pagination */}
                            <div className="pro-pagination-style text-center mt-30">
                                <Paginator
                                    totalRecords={sortedProducts.length}
                                    pageLimit={pageLimit}
                                    pageNeighbours={2}
                                    setOffset={setOffset}
                                    currentPage={currentPage}
                                    setCurrentPage={setCurrentPage}
                                    pageContainerClass="mb-0 mt-0"
                                    pagePrevText="«"
                                    pageNextText="»"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default ProductList;
